module.exports = __webpack_public_path__ + "static/media/saveBlue.3cc463b2.svg";